var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-fristStep"},[_c('choose-park',{ref:"choosePark",attrs:{"is-choose":true,"choose-ids":_vm.chooseIds,"init-choose-ids":_vm.initChooseIds,"is-register":_vm.isRegister},on:{"changeProject":_vm.changeProject}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }